export const mean = (values) =>
  values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : 0;

export const median = (values) => {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
};

export const stdDev = (values) => {
  if (values.length < 2) return 0;
  const average = mean(values);
  return Math.sqrt(values.reduce((sum, value) => sum + (value - average) ** 2, 0) / (values.length - 1));
};

export const min = (values) => (values.length ? Math.min(...values) : 0);

export const max = (values) => (values.length ? Math.max(...values) : 0);

export const percentile = (values, p) => {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const index = (sorted.length - 1) * p;
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  if (lower === upper) return sorted[lower];
  return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower);
};

export const shannonEntropy = (distribution) => {
  const total = distribution.reduce((sum, value) => sum + value, 0);
  if (total <= 0) return 0;
  return -distribution
    .filter((value) => value > 0)
    .reduce((sum, value) => {
      const p = value / total;
      return sum + p * Math.log2(p);
    }, 0);
};

export const normalizedEntropy = (distribution) => {
  const entropy = shannonEntropy(distribution);
  if (entropy === 0 || distribution.length <= 1) return 0;
  return entropy / Math.log2(distribution.length);
};

export const giniCoefficient = (values) => {
  const n = values.length;
  if (n === 0) return 0;
  const total = values.reduce((sum, value) => sum + value, 0);
  if (total === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const weighted = sorted.reduce((sum, value, index) => sum + (index + 1) * value, 0);
  return (2 * weighted) / (n * total) - (n + 1) / n;
};

export const zScore = (value, average, deviation) => (deviation === 0 ? 0 : (value - average) / deviation);

export const rankPercentile = (value, values) => {
  if (values.length === 0) return 0;
  const below = values.filter((entry) => entry < value).length;
  const equal = values.filter((entry) => entry === value).length;
  return ((below + 0.5 * equal) / values.length) * 100;
};
